// store.js
import Vue from 'vue';

const state = Vue.observable({ carrier: '' });
export default state;
